module.exports = __webpack_public_path__ + "img/logo-m2n.f8a8adb7.svg";